import AuthService from 'services/auth-service';
import { endHubSession } from 'services/hub-auth-service';
import { clearLocalSession } from 'services/session';

/**
 * Every explicit sign-out: the user's, or the boot's. A Hub-issued session is
 * ended on the Hub too; the request goes out before the local sign-out and is
 * not waited for. Only the token the Hub issued, read before it is cleared,
 * never one switched to, which may be a user's shared password-session token.
 *
 * Not for a session the monitor judged dead: there is nothing left to end.
 */
export const signOut = (): void => {
  const hubToken = AuthService.getHubToken();
  if (hubToken) {
    endHubSession(hubToken);
  }
  clearLocalSession();
};
